import { useLayoutEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import WaterMarkPng from '~/assets/images/watermark.png'
import { useBreakpoint } from '~/hooks'

const StyledWaterMark = styled.img<{ hasAd?: boolean }>`
  margin: 0 auto;
  padding: 2rem 0;
  display: block;
  max-width: 120px;

  ${({ hasAd }) =>
    hasAd &&
    css`
      padding-bottom: 8rem;
    `}
`

export const WaterMark = () => {
  const { isBreakPointLG } = useBreakpoint()
  const [hasAd, setHasAd] = useState(false)

  useLayoutEffect(() => {
    if (document.querySelector('.ad')) {
      setHasAd(true)
    }
  }, [])

  if (!isBreakPointLG) return null

  return (
    <div style={{ width: '100%' }}>
      <StyledWaterMark src={WaterMarkPng.src} hasAd={hasAd} />
    </div>
  )
}
